<template>
	<div id="embeddedWeb">
		<iframe id="iframe" :src="resuouce" v-if="loaded"></iframe>
	</div>
</template>
<script>
import { Toast } from 'vant';
import tool from '../../../kits/Tools.js';
	export default {
		data(){
			return {
				loaded:false,
				resuouce:""
			}
		},
		props:['currentMid','mid'],
		watch:{
			currentMid(){
				if(!this.loaded && this.currentMid == this.mid){
					
					this.loaded = true;
					Toast.loading({
					  mask: true,
					  message: '加载中...'
					});
					
					var that = this;
					var option = 'ds_id='+tool.getQueryDsId()+'&mid='+this.mid;
					this.axios.post(tool.baseUrl3() + '/index/picText', option).then(function(data) {
						console.log(data);
						console.log("成功了");
						that.resuouce = data.data.data.content;
					}).catch(function(data) {
						console.log('错误' + data)
					})
					
				}
			}
		}
	}
</script>

<style scoped>
#embeddedWeb {
	width: 100% !important;
	overflow-x: auto;
}

#iframe {
	width: 100% !important;
	border: none;
	height: 100%;
	overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// EmbeddedWeb.vue?6130ba1c